import React from 'react'
import ReactDOM from 'react-dom/client'
import '../../assets/css/rebate-widget.css';
import RebateWidget from './component/RebateWidget';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const headerBlock : HTMLElement  = document.getElementById('rebate_widget') as HTMLElement;
if(headerBlock)
{
    const navigationBlock : HTMLElement = headerBlock.appendChild(document.createElement("div"));
    const root = ReactDOM.createRoot(navigationBlock); //createPortal(component, domelement)

    const selectedProductUniqueName : string | null = headerBlock.getAttribute("data-productUniqueName");
    const selectedZipCode: string | null  = headerBlock.getAttribute("data-zipCode");
    
    root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
        <RebateWidget selectedProductUniqueName={selectedProductUniqueName} selectedZipCode={selectedZipCode} incentiveId={null} />
        </QueryClientProvider>
    </React.StrictMode>,
    )

} 
